"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trackingHelper = require("../trackingHelper");
/**
 * spec: https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1531100643
 */
function trackSearchSuggestionsClicked(payload) {
  (0, _trackingHelper.trackEvent)('Search Suggestion Clicked', payload);
}
var _default = exports.default = trackSearchSuggestionsClicked;